import type { SxProps, Theme } from "@mui/material";

import type { CanvasAnimationLayoutVariant } from "./canvasBackgroundTheme";

export function getCanvasAnimationLayerSx(variant: CanvasAnimationLayoutVariant = "viewportFixed"): SxProps<Theme> {
  if (variant === "layerFill") {
    return {
      position: "absolute",
      inset: 0,
      display: "block",
      width: "100%",
      height: "100%",
      maxWidth: "100%",
      maxHeight: "100%",
      overflow: "hidden",
      zIndex: 0,
      pointerEvents: "none",
    };
  }

  return {
    position: "fixed",
    top: 0,
    left: 0,
    display: "block",
    width: "100vw",
    height: "100vh",
    maxWidth: "100vw",
    maxHeight: "100vh",
    overflow: "hidden",
    zIndex: -1,
    pointerEvents: "none",
    "@supports (height: 100dvh)": {
      height: "100dvh",
      maxHeight: "100dvh",
    },
  };
}
